import { default as _91_46_46_46not_45found_93MuDUKCPly3Meta } from "C:/FE02/_work/305/s/Gallery/pages/[...not-found].vue?macro=true";
import { default as aboutdcPo0jJJ3kMeta } from "C:/FE02/_work/305/s/Gallery/pages/about.vue?macro=true";
import { default as account_45createdyzdC3tHa5AMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/account-created.vue?macro=true";
import { default as additional_45information4QZkCG2vVaMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/additional-information.vue?macro=true";
import { default as addressesBpe3mqUZJlMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/addresses.vue?macro=true";
import { default as amendmentgYw26xiEyvMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/amendment.vue?macro=true";
import { default as indexJ1tqBO2ZVHMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/bank-account/index.vue?macro=true";
import { default as requestedHp1DhFPyqUMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/bank-account/requested.vue?macro=true";
import { default as contract_45signingeHHWm3EWuyMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/contract-signing.vue?macro=true";
import { default as document_45updateKfUpsCfiEqMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/document-update.vue?macro=true";
import { default as documents_45checkugDrTh6BYvMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/documents-check.vue?macro=true";
import { default as indexPv5R6k89NNMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/index.vue?macro=true";
import { default as requestedW8uotxAxEDMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/requested.vue?macro=true";
import { default as upload_45documents9EIqB2oczkMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/upload-documents.vue?macro=true";
import { default as personal_45data8WbvtzFslgMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/personal-data.vue?macro=true";
import { default as phone_45number_45verificationKpM1mYdRCZMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/phone-number-verification.vue?macro=true";
import { default as indexI8aUvOslE6Meta } from "C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/index.vue?macro=true";
import { default as requestedGlGo7maNPZMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/requested.vue?macro=true";
import { default as questionnaire9WskltdTL0Meta } from "C:/FE02/_work/305/s/Gallery/pages/account/questionnaire.vue?macro=true";
import { default as indexG6ZRudA0HJMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/index.vue?macro=true";
import { default as requestedY8PT1flL05Meta } from "C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/requested.vue?macro=true";
import { default as verificationFEsCNz13dUMeta } from "C:/FE02/_work/305/s/Gallery/pages/account/verification.vue?macro=true";
import { default as annual_45reportseIAKqvJreBMeta } from "C:/FE02/_work/305/s/Gallery/pages/annual-reports.vue?macro=true";
import { default as bankidUTnin6WP1eMeta } from "C:/FE02/_work/305/s/Gallery/pages/bankid.vue?macro=true";
import { default as contactEQhtpIz53SMeta } from "C:/FE02/_work/305/s/Gallery/pages/contact.vue?macro=true";
import { default as contractual_45documentationrtcyslY3OBMeta } from "C:/FE02/_work/305/s/Gallery/pages/contractual-documentation.vue?macro=true";
import { default as _91id_93vfHYPpti47Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/[id].vue?macro=true";
import { default as _91id_93ve8qaWu9btMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue?macro=true";
import { default as newTGXXdRFAnGMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue?macro=true";
import { default as indexdp0y8W0uy3Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/index.vue?macro=true";
import { default as my_45advertisements5o2ZrpgoLLMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue?macro=true";
import { default as termsjGP9KRFoDpMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/terms.vue?macro=true";
import { default as _91id_93HvvNQSpfhBMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue?macro=true";
import { default as indexY6G4mtbwZjMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/index.vue?macro=true";
import { default as newLPYH4z2USmMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/new.vue?macro=true";
import { default as advertising_45spacee4tFKbFuFyMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space.vue?macro=true";
import { default as depositPSC7QSwwutMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/deposit.vue?macro=true";
import { default as indexo6jasSbzS2Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/index.vue?macro=true";
import { default as purchase_45instructionsjesRDYHdNiMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/purchase-instructions.vue?macro=true";
import { default as transactions_45history0BDTMHJiJqMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/transactions-history.vue?macro=true";
import { default as confirmation7Wj5lAH50AMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue?macro=true";
import { default as index27yYfQUfUYMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/index.vue?macro=true";
import { default as financeZNEQAfwL3wMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/finance.vue?macro=true";
import { default as indexQ6r4uoQsCXMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue?macro=true";
import { default as unique_45exhibition_45alfons_45mucha6rN7cjsvonMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue?macro=true";
import { default as vouchershyJZnxTHUeMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue?macro=true";
import { default as gifts_45and_45benefitsLVqsuIiMelMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits.vue?macro=true";
import { default as indexYAqC6qX6uxMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/index.vue?macro=true";
import { default as index1azz13rxJbMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/index.vue?macro=true";
import { default as _91slug_93QoEyHLHzKKMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue?macro=true";
import { default as indexDB7BN3DFdDMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/index.vue?macro=true";
import { default as investments_45offerd6JVVLtIopMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer.vue?macro=true";
import { default as my_45investmentsVFbC2kUXJPMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/my-investments.vue?macro=true";
import { default as votingR9klfL7ws9Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/voting.vue?macro=true";
import { default as investmentscIVQonfk8WMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/investments.vue?macro=true";
import { default as add_45accountIRGnDSXz9FMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/add-account.vue?macro=true";
import { default as additional_45settings2BzQpIUvtMMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/additional-settings.vue?macro=true";
import { default as indexkmWIxSVubpMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue?macro=true";
import { default as requestedMEtiFYhICmMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue?macro=true";
import { default as upload_45documentLS3cfVf0YxMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue?macro=true";
import { default as indexfbAWT0s5SOMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue?macro=true";
import { default as delete_45account8nqrwHzskQMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/delete-account.vue?macro=true";
import { default as indexdLzf4qMDM1Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/index.vue?macro=true";
import { default as requestedVw2cGBYkDWMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/requested.vue?macro=true";
import { default as edit_45personal_45information318j3CPndBMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/edit-personal-information.vue?macro=true";
import { default as email_45changeKtCvmXG4t1Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-change.vue?macro=true";
import { default as email_45preferencesryY0V8Zfh7Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-preferences.vue?macro=true";
import { default as czech_45pointQOQTauGZMpMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue?macro=true";
import { default as indexzVJGVQhNToMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/index.vue?macro=true";
import { default as index7wjuBAdivaMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/index.vue?macro=true";
import { default as mailing_45address_45changezvC2eBNWH0Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/mailing-address-change.vue?macro=true";
import { default as indexqJe4vRPAXGMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/index.vue?macro=true";
import { default as requested49Cs8hOIL7Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/requested.vue?macro=true";
import { default as upload_45documentsrotQSkP3JkMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue?macro=true";
import { default as indexXsObEKmmv3Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue?macro=true";
import { default as requestedCUCZdmrNMyMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue?macro=true";
import { default as upload_45documentsCCk1t1xT9LMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue?macro=true";
import { default as additional_45informationNxHlOIwydtMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue?macro=true";
import { default as indexQqhRhilfU1Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue?macro=true";
import { default as indexuXsk5i4ubuMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue?macro=true";
import { default as requestedFdKuQNQBVMMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue?macro=true";
import { default as indexW1bwhlDhiMMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue?macro=true";
import { default as requestedy9aj0TZDl2Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue?macro=true";
import { default as index5sDSphOetIMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue?macro=true";
import { default as requestedFmAYniPzTcMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue?macro=true";
import { default as personal_45data_45confirmationHyv8Y4bzZFMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue?macro=true";
import { default as phone_45changeRbrrBiXwy2Meta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/phone-change.vue?macro=true";
import { default as indexaee36nCatwMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/index.vue?macro=true";
import { default as password_45change9hupZwok8NMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/password-change.vue?macro=true";
import { default as documentsD2Z2ZvAyKLMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue?macro=true";
import { default as indexxXhhy3xs1EMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue?macro=true";
import { default as statements_45and_45confirmationsayZtHuo1cpMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue?macro=true";
import { default as profileKpkKyjOVFMMeta } from "C:/FE02/_work/305/s/Gallery/pages/dashboard/profile.vue?macro=true";
import { default as element3jtdZ1Lrm3Meta } from "C:/FE02/_work/305/s/Gallery/pages/element.vue?macro=true";
import { default as email_45verification3cDfCd66veMeta } from "C:/FE02/_work/305/s/Gallery/pages/external/email-verification.vue?macro=true";
import { default as impersonationZway0B0rjoMeta } from "C:/FE02/_work/305/s/Gallery/pages/external/impersonation.vue?macro=true";
import { default as loginFDhDnRs7YlMeta } from "C:/FE02/_work/305/s/Gallery/pages/external/login.vue?macro=true";
import { default as password_45resetqMtVBlpOKSMeta } from "C:/FE02/_work/305/s/Gallery/pages/external/password-reset.vue?macro=true";
import { default as _91slug_93hIcsjXap5pMeta } from "C:/FE02/_work/305/s/Gallery/pages/faq/[slug].vue?macro=true";
import { default as indexUm0a7HbU2ZMeta } from "C:/FE02/_work/305/s/Gallery/pages/faq/index.vue?macro=true";
import { default as faqXPuEsbCiWHMeta } from "C:/FE02/_work/305/s/Gallery/pages/faq.vue?macro=true";
import { default as forgotten_45passworddb8ZReH7iDMeta } from "C:/FE02/_work/305/s/Gallery/pages/forgotten-password.vue?macro=true";
import { default as how_45does_45it_45workqsdzVApNxkMeta } from "C:/FE02/_work/305/s/Gallery/pages/how-does-it-work.vue?macro=true";
import { default as index9HCdMm5aU7Meta } from "C:/FE02/_work/305/s/Gallery/pages/index.vue?macro=true";
import { default as _91slug_93S8wyoMFzzMMeta } from "C:/FE02/_work/305/s/Gallery/pages/investments-offer/[slug].vue?macro=true";
import { default as indexx4zPNnnwxaMeta } from "C:/FE02/_work/305/s/Gallery/pages/investments-offer/index.vue?macro=true";
import { default as loginLI1f4JMjsKMeta } from "C:/FE02/_work/305/s/Gallery/pages/login.vue?macro=true";
import { default as obligatory_45published_45informationLH9NZpgigNMeta } from "C:/FE02/_work/305/s/Gallery/pages/obligatory-published-information.vue?macro=true";
import { default as privacy_45settingsjLJvKgGdk2Meta } from "C:/FE02/_work/305/s/Gallery/pages/privacy-settings.vue?macro=true";
import { default as registrationCG6YtlffPJMeta } from "C:/FE02/_work/305/s/Gallery/pages/registration.vue?macro=true";
import { default as securityqhcbMnHnN3Meta } from "C:/FE02/_work/305/s/Gallery/pages/security.vue?macro=true";
export default [
  {
    name: "notfound___cs___default",
    path: "/:notfound(.*)*",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/[...not-found].vue").then(m => m.default || m)
  },
  {
    name: "notfound___cs",
    path: "/cs/:notfound(.*)*",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/[...not-found].vue").then(m => m.default || m)
  },
  {
    name: "about___cs___default",
    path: "/o-nas",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "about___cs",
    path: "/cs/o-nas",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "account-account-created___cs___default",
    path: "/ucet/ucet-vytvoren",
    meta: account_45createdyzdC3tHa5AMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/account-created.vue").then(m => m.default || m)
  },
  {
    name: "account-account-created___cs",
    path: "/cs/ucet/ucet-vytvoren",
    meta: account_45createdyzdC3tHa5AMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/account-created.vue").then(m => m.default || m)
  },
  {
    name: "account-additional-information___cs___default",
    path: "/ucet/dalsi-informace",
    meta: additional_45information4QZkCG2vVaMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "account-additional-information___cs",
    path: "/cs/ucet/dalsi-informace",
    meta: additional_45information4QZkCG2vVaMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "account-addresses___cs___default",
    path: "/ucet/adresy",
    meta: addressesBpe3mqUZJlMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/addresses.vue").then(m => m.default || m)
  },
  {
    name: "account-addresses___cs",
    path: "/cs/ucet/adresy",
    meta: addressesBpe3mqUZJlMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/addresses.vue").then(m => m.default || m)
  },
  {
    name: "account-amendment___cs___default",
    path: "/ucet/dodatek",
    meta: amendmentgYw26xiEyvMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/amendment.vue").then(m => m.default || m)
  },
  {
    name: "account-amendment___cs",
    path: "/cs/ucet/dodatek",
    meta: amendmentgYw26xiEyvMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/amendment.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account___cs___default",
    path: "/ucet/bankovni-ucet",
    meta: indexJ1tqBO2ZVHMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/bank-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account___cs",
    path: "/cs/ucet/bankovni-ucet",
    meta: indexJ1tqBO2ZVHMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/bank-account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account-requested___cs___default",
    path: "/ucet/bankovni-ucet/overeni",
    meta: requestedHp1DhFPyqUMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/bank-account/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-bank-account-requested___cs",
    path: "/cs/ucet/bankovni-ucet/overeni",
    meta: requestedHp1DhFPyqUMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/bank-account/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-contract-signing___cs___default",
    path: "/ucet/podpis-smlouvy",
    meta: contract_45signingeHHWm3EWuyMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/contract-signing.vue").then(m => m.default || m)
  },
  {
    name: "account-contract-signing___cs",
    path: "/cs/ucet/podpis-smlouvy",
    meta: contract_45signingeHHWm3EWuyMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/contract-signing.vue").then(m => m.default || m)
  },
  {
    name: "account-document-update___cs___default",
    path: "/ucet/aktualizace-dokladu",
    meta: document_45updateKfUpsCfiEqMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/document-update.vue").then(m => m.default || m)
  },
  {
    name: "account-document-update___cs",
    path: "/cs/ucet/aktualizace-dokladu",
    meta: document_45updateKfUpsCfiEqMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/document-update.vue").then(m => m.default || m)
  },
  {
    name: "account-documents-check___cs___default",
    path: "/ucet/kontrola-dokladu",
    meta: documents_45checkugDrTh6BYvMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/documents-check.vue").then(m => m.default || m)
  },
  {
    name: "account-documents-check___cs",
    path: "/cs/ucet/kontrola-dokladu",
    meta: documents_45checkugDrTh6BYvMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/documents-check.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification___cs___default",
    path: "/ucet/overeni-identity",
    meta: indexPv5R6k89NNMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification___cs",
    path: "/cs/ucet/overeni-identity",
    meta: indexPv5R6k89NNMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-requested___cs___default",
    path: "/ucet/overeni-identity/overeni",
    meta: requestedW8uotxAxEDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-requested___cs",
    path: "/cs/ucet/overeni-identity/overeni",
    meta: requestedW8uotxAxEDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-upload-documents___cs___default",
    path: "/ucet/overeni-identity/nahrat-doklady",
    meta: upload_45documents9EIqB2oczkMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "account-identity-verification-upload-documents___cs",
    path: "/cs/ucet/overeni-identity/nahrat-doklady",
    meta: upload_45documents9EIqB2oczkMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/identity-verification/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "account-personal-data___cs___default",
    path: "/ucet/osobni-udaje",
    meta: personal_45data8WbvtzFslgMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/personal-data.vue").then(m => m.default || m)
  },
  {
    name: "account-personal-data___cs",
    path: "/cs/ucet/osobni-udaje",
    meta: personal_45data8WbvtzFslgMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/personal-data.vue").then(m => m.default || m)
  },
  {
    name: "account-phone-number-verification___cs___default",
    path: "/ucet/overeni-telefonniho-cisla",
    meta: phone_45number_45verificationKpM1mYdRCZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/phone-number-verification.vue").then(m => m.default || m)
  },
  {
    name: "account-phone-number-verification___cs",
    path: "/cs/ucet/overeni-telefonniho-cisla",
    meta: phone_45number_45verificationKpM1mYdRCZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/phone-number-verification.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person___cs___default",
    path: "/ucet/politicky-exponovana-osoba",
    meta: indexI8aUvOslE6Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person___cs",
    path: "/cs/ucet/politicky-exponovana-osoba",
    meta: indexI8aUvOslE6Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person-requested___cs___default",
    path: "/ucet/politicky-exponovana-osoba/overeni",
    meta: requestedGlGo7maNPZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-politically-exposed-person-requested___cs",
    path: "/cs/ucet/politicky-exponovana-osoba/overeni",
    meta: requestedGlGo7maNPZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-questionnaire___cs___default",
    path: "/ucet/dotaznik",
    meta: questionnaire9WskltdTL0Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/questionnaire.vue").then(m => m.default || m)
  },
  {
    name: "account-questionnaire___cs",
    path: "/cs/ucet/dotaznik",
    meta: questionnaire9WskltdTL0Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/questionnaire.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement___cs___default",
    path: "/ucet/potvrzeni-zdroje-prijmu",
    meta: indexG6ZRudA0HJMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement___cs",
    path: "/cs/ucet/potvrzeni-zdroje-prijmu",
    meta: indexG6ZRudA0HJMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement-requested___cs___default",
    path: "/ucet/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedY8PT1flL05Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-source-of-income-statement-requested___cs",
    path: "/cs/ucet/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedY8PT1flL05Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/source-of-income-statement/requested.vue").then(m => m.default || m)
  },
  {
    name: "account-verification___cs___default",
    path: "/ucet/verifikace",
    meta: verificationFEsCNz13dUMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/verification.vue").then(m => m.default || m)
  },
  {
    name: "account-verification___cs",
    path: "/cs/ucet/verifikace",
    meta: verificationFEsCNz13dUMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/account/verification.vue").then(m => m.default || m)
  },
  {
    name: "annual-reports___cs___default",
    path: "/vyrocni-zpravy",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/annual-reports.vue").then(m => m.default || m)
  },
  {
    name: "annual-reports___cs",
    path: "/cs/vyrocni-zpravy",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/annual-reports.vue").then(m => m.default || m)
  },
  {
    name: "bankid___cs___default",
    path: "/bankid",
    meta: bankidUTnin6WP1eMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/bankid.vue").then(m => m.default || m)
  },
  {
    name: "bankid___cs",
    path: "/cs/bankid",
    meta: bankidUTnin6WP1eMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/bankid.vue").then(m => m.default || m)
  },
  {
    name: "contact___cs___default",
    path: "/kontakt",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contact___cs",
    path: "/cs/kontakt",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contractual-documentation___cs___default",
    path: "/smluvni-dokumentace",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/contractual-documentation.vue").then(m => m.default || m)
  },
  {
    name: "contractual-documentation___cs",
    path: "/cs/smluvni-dokumentace",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/contractual-documentation.vue").then(m => m.default || m)
  },
  {
    name: advertising_45spacee4tFKbFuFyMeta?.name,
    path: "/souhrn/inzertni-plocha",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-advertising-space-id___cs___default",
    path: ":id()",
    meta: _91id_93vfHYPpti47Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-id___cs___default",
    path: "inzerat/:id()",
    meta: _91id_93ve8qaWu9btMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-new___cs___default",
    path: "inzerat/novy",
    meta: newTGXXdRFAnGMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space___cs___default",
    path: "/souhrn/inzertni-plocha",
    meta: indexdp0y8W0uy3Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-my-advertisements___cs___default",
    path: "moje-inzeraty",
    meta: my_45advertisements5o2ZrpgoLLMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-terms___cs___default",
    path: "podminky",
    meta: termsjGP9KRFoDpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/terms.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-id___cs___default",
    path: "pokyny-k-prevodu/:id()",
    meta: _91id_93HvvNQSpfhBMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades___cs___default",
    path: "pokyny-k-prevodu",
    meta: indexY6G4mtbwZjMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-new___cs___default",
    path: "pokyny-k-prevodu/novy",
    meta: newLPYH4z2USmMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: advertising_45spacee4tFKbFuFyMeta?.name,
    path: "/cs/souhrn/inzertni-plocha",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-advertising-space-id___cs",
    path: ":id()",
    meta: _91id_93vfHYPpti47Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-id___cs",
    path: "inzerat/:id()",
    meta: _91id_93ve8qaWu9btMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-advertisement-new___cs",
    path: "inzerat/novy",
    meta: newTGXXdRFAnGMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/advertisement/new.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space___cs",
    path: "/cs/souhrn/inzertni-plocha",
    meta: indexdp0y8W0uy3Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-my-advertisements___cs",
    path: "moje-inzeraty",
    meta: my_45advertisements5o2ZrpgoLLMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/my-advertisements.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-terms___cs",
    path: "podminky",
    meta: termsjGP9KRFoDpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/terms.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-id___cs",
    path: "pokyny-k-prevodu/:id()",
    meta: _91id_93HvvNQSpfhBMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades___cs",
    path: "pokyny-k-prevodu",
    meta: indexY6G4mtbwZjMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-advertising-space-trades-new___cs",
    path: "pokyny-k-prevodu/novy",
    meta: newLPYH4z2USmMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/advertising-space/trades/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: financeZNEQAfwL3wMeta?.name,
    path: "/souhrn/penize",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-finance-deposit___cs___default",
    path: "vklad",
    meta: depositPSC7QSwwutMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/deposit.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance___cs___default",
    path: "/souhrn/penize",
    meta: indexo6jasSbzS2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-purchase-instructions___cs___default",
    path: "pokyny",
    meta: purchase_45instructionsjesRDYHdNiMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/purchase-instructions.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-transactions-history___cs___default",
    path: "transakcni-historie",
    meta: transactions_45history0BDTMHJiJqMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/transactions-history.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal-confirmation___cs___default",
    path: "vyber/potvrzeni",
    meta: confirmation7Wj5lAH50AMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal___cs___default",
    path: "vyber",
    meta: index27yYfQUfUYMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: financeZNEQAfwL3wMeta?.name,
    path: "/cs/souhrn/penize",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-finance-deposit___cs",
    path: "vklad",
    meta: depositPSC7QSwwutMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/deposit.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance___cs",
    path: "/cs/souhrn/penize",
    meta: indexo6jasSbzS2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-purchase-instructions___cs",
    path: "pokyny",
    meta: purchase_45instructionsjesRDYHdNiMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/purchase-instructions.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-transactions-history___cs",
    path: "transakcni-historie",
    meta: transactions_45history0BDTMHJiJqMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/transactions-history.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal-confirmation___cs",
    path: "vyber/potvrzeni",
    meta: confirmation7Wj5lAH50AMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-finance-withdrawal___cs",
    path: "vyber",
    meta: index27yYfQUfUYMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/finance/withdrawal/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: gifts_45and_45benefitsLVqsuIiMelMeta?.name,
    path: "/souhrn/darky-a-vyhody",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-gifts-and-benefits___cs___default",
    path: "",
    meta: indexQ6r4uoQsCXMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-unique-exhibition-alfons-mucha___cs___default",
    path: "unikatni-vystava-alfons-mucha",
    meta: unique_45exhibition_45alfons_45mucha6rN7cjsvonMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-vouchers___cs___default",
    path: "darkove-poukazy",
    meta: vouchershyJZnxTHUeMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue").then(m => m.default || m)
  }
]
  },
  {
    name: gifts_45and_45benefitsLVqsuIiMelMeta?.name,
    path: "/cs/souhrn/darky-a-vyhody",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-gifts-and-benefits___cs",
    path: "",
    meta: indexQ6r4uoQsCXMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-unique-exhibition-alfons-mucha___cs",
    path: "unikatni-vystava-alfons-mucha",
    meta: unique_45exhibition_45alfons_45mucha6rN7cjsvonMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/unique-exhibition-alfons-mucha.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-gifts-and-benefits-vouchers___cs",
    path: "darkove-poukazy",
    meta: vouchershyJZnxTHUeMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/gifts-and-benefits/vouchers.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard___cs___default",
    path: "/souhrn",
    meta: indexYAqC6qX6uxMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard___cs",
    path: "/cs/souhrn",
    meta: indexYAqC6qX6uxMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: investmentscIVQonfk8WMeta?.name,
    path: "/souhrn/investice",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments___cs___default",
    path: "",
    meta: index1azz13rxJbMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/index.vue").then(m => m.default || m)
  },
  {
    name: investments_45offerd6JVVLtIopMeta?.name,
    path: "nabidka-investic",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments-investments-offer-slug___cs___default",
    path: "/souhrn/investice/:slug()",
    meta: _91slug_93QoEyHLHzKKMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-investments-offer___cs___default",
    path: "/souhrn/investice/nabidka-investic",
    meta: indexDB7BN3DFdDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-investments-my-investments___cs___default",
    path: "moje-investice",
    meta: my_45investmentsVFbC2kUXJPMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/my-investments.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-voting___cs___default",
    path: "hlasovani",
    meta: votingR9klfL7ws9Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/voting.vue").then(m => m.default || m)
  }
]
  },
  {
    name: investmentscIVQonfk8WMeta?.name,
    path: "/cs/souhrn/investice",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments___cs",
    path: "",
    meta: index1azz13rxJbMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/index.vue").then(m => m.default || m)
  },
  {
    name: investments_45offerd6JVVLtIopMeta?.name,
    path: "nabidka-investic",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-investments-investments-offer-slug___cs",
    path: "/cs/souhrn/investice/:slug()",
    meta: _91slug_93QoEyHLHzKKMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-investments-offer___cs",
    path: "/cs/souhrn/investice/nabidka-investic",
    meta: indexDB7BN3DFdDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/investments-offer/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-investments-my-investments___cs",
    path: "moje-investice",
    meta: my_45investmentsVFbC2kUXJPMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/my-investments.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-investments-voting___cs",
    path: "hlasovani",
    meta: votingR9klfL7ws9Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/investments/voting.vue").then(m => m.default || m)
  }
]
  },
  {
    name: profileKpkKyjOVFMMeta?.name,
    path: "/dashboard/profile",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-add-account___cs___default",
    path: "/souhrn/profil/pridat-ucet",
    meta: add_45accountIRGnDSXz9FMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/add-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-additional-settings___cs___default",
    path: "/souhrn/profil/dalsi-nastaveni",
    meta: additional_45settings2BzQpIUvtMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/additional-settings.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat",
    meta: indexkmWIxSVubpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-requested___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat/overeni",
    meta: requestedMEtiFYhICmMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-upload-document___cs___default",
    path: "/souhrn/profil/bankovni-ucty/pridat/nahrat-doklad",
    meta: upload_45documentLS3cfVf0YxMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts___cs___default",
    path: "/souhrn/profil/bankovni-ucty",
    meta: indexfbAWT0s5SOMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-delete-account___cs___default",
    path: "/souhrn/profil/zruseni-uctu",
    meta: delete_45account8nqrwHzskQMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/delete-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update___cs___default",
    path: "/souhrn/profil/aktualizace-dokladu",
    meta: indexdLzf4qMDM1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update-requested___cs___default",
    path: "/souhrn/profil/aktualizace-dokladu/overeni",
    meta: requestedVw2cGBYkDWMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-edit-personal-information___cs___default",
    path: "/souhrn/profil/uprava-osobnich-udaju",
    meta: edit_45personal_45information318j3CPndBMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/edit-personal-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-change___cs___default",
    path: "/souhrn/profil/zmena-e-mailu",
    meta: email_45changeKtCvmXG4t1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-preferences___cs___default",
    path: "/souhrn/profil/e-mailova-sdeleni",
    meta: email_45preferencesryY0V8Zfh7Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-preferences.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification-czech-point___cs___default",
    path: "/souhrn/profil/overeni-totoznosti/czech-point",
    meta: czech_45pointQOQTauGZMpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification___cs___default",
    path: "/souhrn/profil/overeni-totoznosti",
    meta: indexzVJGVQhNToMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile___cs___default",
    path: "/souhrn/profil",
    meta: index7wjuBAdivaMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-mailing-address-change___cs___default",
    path: "/souhrn/profil/zmena-korespondencni-adresy",
    meta: mailing_45address_45changezvC2eBNWH0Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/mailing-address-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change___cs___default",
    path: "/souhrn/profil/zmena-jmena",
    meta: indexqJe4vRPAXGMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-requested___cs___default",
    path: "/souhrn/profil/zmena-jmena/overeni",
    meta: requested49Cs8hOIL7Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-upload-documents___cs___default",
    path: "/souhrn/profil/zmena-jmena/nahrat-doklady",
    meta: upload_45documentsrotQSkP3JkMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy",
    meta: indexXsObEKmmv3Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-requested___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy/overeni",
    meta: requestedCUCZdmrNMyMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-upload-documents___cs___default",
    path: "/souhrn/profil/zmena-travale-adresy/nahrat-doklady",
    meta: upload_45documentsCCk1t1xT9LMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: personal_45data_45confirmationHyv8Y4bzZFMeta?.name,
    path: "personal-data-confirmation",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-personal-data-confirmation-additional-information___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/dalsi-informace",
    meta: additional_45informationNxHlOIwydtMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation___cs___default",
    path: "/souhrn/profil/aktualizace-udaju",
    meta: indexQqhRhilfU1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/novy-dokument",
    meta: indexuXsk5i4ubuMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/novy-dokument/overeni",
    meta: requestedFdKuQNQBVMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba",
    meta: indexW1bwhlDhiMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba/overeni",
    meta: requestedy9aj0TZDl2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu",
    meta: index5sDSphOetIMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement-requested___cs___default",
    path: "/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedFmAYniPzTcMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-profile-phone-change___cs___default",
    path: "/souhrn/profil/zmena-telefonu",
    meta: phone_45changeRbrrBiXwy2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/phone-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security___cs___default",
    path: "/souhrn/profil/bezpecnost",
    meta: indexaee36nCatwMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security-password-change___cs___default",
    path: "/souhrn/profil/bezpecnost/zmena-hesla",
    meta: password_45change9hupZwok8NMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/password-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-documents___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty/dokumenty",
    meta: documentsD2Z2ZvAyKLMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty",
    meta: indexxXhhy3xs1EMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-statements-and-confirmations___cs___default",
    path: "/souhrn/profil/vypisy-a-dokumenty/vypisy-a-potvrzeni",
    meta: statements_45and_45confirmationsayZtHuo1cpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue").then(m => m.default || m)
  }
]
  },
  {
    name: profileKpkKyjOVFMMeta?.name,
    path: "/cs/dashboard/profile",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-add-account___cs",
    path: "/cs/souhrn/profil/pridat-ucet",
    meta: add_45accountIRGnDSXz9FMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/add-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-additional-settings___cs",
    path: "/cs/souhrn/profil/dalsi-nastaveni",
    meta: additional_45settings2BzQpIUvtMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/additional-settings.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat",
    meta: indexkmWIxSVubpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-requested___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat/overeni",
    meta: requestedMEtiFYhICmMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts-add-upload-document___cs",
    path: "/cs/souhrn/profil/bankovni-ucty/pridat/nahrat-doklad",
    meta: upload_45documentLS3cfVf0YxMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/add/upload-document.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-bank-accounts___cs",
    path: "/cs/souhrn/profil/bankovni-ucty",
    meta: indexfbAWT0s5SOMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/bank-accounts/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-delete-account___cs",
    path: "/cs/souhrn/profil/zruseni-uctu",
    meta: delete_45account8nqrwHzskQMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/delete-account.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update___cs",
    path: "/cs/souhrn/profil/aktualizace-dokladu",
    meta: indexdLzf4qMDM1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-document-update-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-dokladu/overeni",
    meta: requestedVw2cGBYkDWMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/document-update/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-edit-personal-information___cs",
    path: "/cs/souhrn/profil/uprava-osobnich-udaju",
    meta: edit_45personal_45information318j3CPndBMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/edit-personal-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-change___cs",
    path: "/cs/souhrn/profil/zmena-e-mailu",
    meta: email_45changeKtCvmXG4t1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-email-preferences___cs",
    path: "/cs/souhrn/profil/e-mailova-sdeleni",
    meta: email_45preferencesryY0V8Zfh7Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/email-preferences.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification-czech-point___cs",
    path: "/cs/souhrn/profil/overeni-totoznosti/czech-point",
    meta: czech_45pointQOQTauGZMpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/czech-point.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-identity-verification___cs",
    path: "/cs/souhrn/profil/overeni-totoznosti",
    meta: indexzVJGVQhNToMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/identity-verification/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile___cs",
    path: "/cs/souhrn/profil",
    meta: index7wjuBAdivaMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-mailing-address-change___cs",
    path: "/cs/souhrn/profil/zmena-korespondencni-adresy",
    meta: mailing_45address_45changezvC2eBNWH0Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/mailing-address-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change___cs",
    path: "/cs/souhrn/profil/zmena-jmena",
    meta: indexqJe4vRPAXGMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-requested___cs",
    path: "/cs/souhrn/profil/zmena-jmena/overeni",
    meta: requested49Cs8hOIL7Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-name-change-upload-documents___cs",
    path: "/cs/souhrn/profil/zmena-jmena/nahrat-doklady",
    meta: upload_45documentsrotQSkP3JkMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/name-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy",
    meta: indexXsObEKmmv3Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-requested___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy/overeni",
    meta: requestedCUCZdmrNMyMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-permanent-address-change-upload-documents___cs",
    path: "/cs/souhrn/profil/zmena-travale-adresy/nahrat-doklady",
    meta: upload_45documentsCCk1t1xT9LMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/permanent-address-change/upload-documents.vue").then(m => m.default || m)
  },
  {
    name: personal_45data_45confirmationHyv8Y4bzZFMeta?.name,
    path: "personal-data-confirmation",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-profile-personal-data-confirmation-additional-information___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/dalsi-informace",
    meta: additional_45informationNxHlOIwydtMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/additional-information.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju",
    meta: indexQqhRhilfU1Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/novy-dokument",
    meta: indexuXsk5i4ubuMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-new-document-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/novy-dokument/overeni",
    meta: requestedFdKuQNQBVMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/new-document/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba",
    meta: indexW1bwhlDhiMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-politically-exposed-person-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/politicky-exponovana-osoba/overeni",
    meta: requestedy9aj0TZDl2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/politically-exposed-person/requested.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu",
    meta: index5sDSphOetIMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-personal-data-confirmation-source-of-income-statement-requested___cs",
    path: "/cs/souhrn/profil/aktualizace-udaju/potvrzeni-zdroje-prijmu/overeni",
    meta: requestedFmAYniPzTcMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/personal-data-confirmation/source-of-income-statement/requested.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "dashboard-profile-phone-change___cs",
    path: "/cs/souhrn/profil/zmena-telefonu",
    meta: phone_45changeRbrrBiXwy2Meta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/phone-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security___cs",
    path: "/cs/souhrn/profil/bezpecnost",
    meta: indexaee36nCatwMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-security-password-change___cs",
    path: "/cs/souhrn/profil/bezpecnost/zmena-hesla",
    meta: password_45change9hupZwok8NMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/security/password-change.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-documents___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty/dokumenty",
    meta: documentsD2Z2ZvAyKLMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/documents.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty",
    meta: indexxXhhy3xs1EMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/index.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-profile-statements-and-documents-statements-and-confirmations___cs",
    path: "/cs/souhrn/profil/vypisy-a-dokumenty/vypisy-a-potvrzeni",
    meta: statements_45and_45confirmationsayZtHuo1cpMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/dashboard/profile/statements-and-documents/statements-and-confirmations.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "element___cs___default",
    path: "/element",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/element.vue").then(m => m.default || m)
  },
  {
    name: "element___cs",
    path: "/cs/element",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/element.vue").then(m => m.default || m)
  },
  {
    name: "external-email-verification___cs___default",
    path: "/external/email-verification",
    meta: email_45verification3cDfCd66veMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/email-verification.vue").then(m => m.default || m)
  },
  {
    name: "external-email-verification___cs",
    path: "/cs/external/email-verification",
    meta: email_45verification3cDfCd66veMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/email-verification.vue").then(m => m.default || m)
  },
  {
    name: "external-impersonation___cs___default",
    path: "/external/impersonation",
    meta: impersonationZway0B0rjoMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/impersonation.vue").then(m => m.default || m)
  },
  {
    name: "external-impersonation___cs",
    path: "/cs/external/impersonation",
    meta: impersonationZway0B0rjoMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/impersonation.vue").then(m => m.default || m)
  },
  {
    name: "external-login___cs___default",
    path: "/external/login",
    meta: loginFDhDnRs7YlMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/login.vue").then(m => m.default || m)
  },
  {
    name: "external-login___cs",
    path: "/cs/external/login",
    meta: loginFDhDnRs7YlMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/login.vue").then(m => m.default || m)
  },
  {
    name: "external-password-reset___cs___default",
    path: "/external/password-reset",
    meta: password_45resetqMtVBlpOKSMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/password-reset.vue").then(m => m.default || m)
  },
  {
    name: "external-password-reset___cs",
    path: "/cs/external/password-reset",
    meta: password_45resetqMtVBlpOKSMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/external/password-reset.vue").then(m => m.default || m)
  },
  {
    name: faqXPuEsbCiWHMeta?.name,
    path: "/faq",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq.vue").then(m => m.default || m),
    children: [
  {
    name: "faq-slug___cs___default",
    path: ":slug()",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq/[slug].vue").then(m => m.default || m)
  },
  {
    name: "faq___cs___default",
    path: "",
    meta: indexUm0a7HbU2ZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqXPuEsbCiWHMeta?.name,
    path: "/cs/faq",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq.vue").then(m => m.default || m),
    children: [
  {
    name: "faq-slug___cs",
    path: ":slug()",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq/[slug].vue").then(m => m.default || m)
  },
  {
    name: "faq___cs",
    path: "",
    meta: indexUm0a7HbU2ZMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/faq/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "forgotten-password___cs___default",
    path: "/zapomenute-heslo",
    meta: forgotten_45passworddb8ZReH7iDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/forgotten-password.vue").then(m => m.default || m)
  },
  {
    name: "forgotten-password___cs",
    path: "/cs/zapomenute-heslo",
    meta: forgotten_45passworddb8ZReH7iDMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/forgotten-password.vue").then(m => m.default || m)
  },
  {
    name: "how-does-it-work___cs___default",
    path: "/jak-to-funguje",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/how-does-it-work.vue").then(m => m.default || m)
  },
  {
    name: "how-does-it-work___cs",
    path: "/cs/jak-to-funguje",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/how-does-it-work.vue").then(m => m.default || m)
  },
  {
    name: "index___cs___default",
    path: "/",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "investments-offer-slug___cs___default",
    path: "/nabidka-investic/:slug()",
    meta: _91slug_93S8wyoMFzzMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "investments-offer-slug___cs",
    path: "/cs/nabidka-investic/:slug()",
    meta: _91slug_93S8wyoMFzzMMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/investments-offer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "investments-offer___cs___default",
    path: "/nabidka-investic",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/investments-offer/index.vue").then(m => m.default || m)
  },
  {
    name: "investments-offer___cs",
    path: "/cs/nabidka-investic",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/investments-offer/index.vue").then(m => m.default || m)
  },
  {
    name: "login___cs___default",
    path: "/prihlasit-se",
    meta: loginLI1f4JMjsKMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___cs",
    path: "/cs/prihlasit-se",
    meta: loginLI1f4JMjsKMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "obligatory-published-information___cs___default",
    path: "/povinne-informace",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/obligatory-published-information.vue").then(m => m.default || m)
  },
  {
    name: "obligatory-published-information___cs",
    path: "/cs/povinne-informace",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/obligatory-published-information.vue").then(m => m.default || m)
  },
  {
    name: "privacy-settings___cs___default",
    path: "/nastaveni-soukromi",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/privacy-settings.vue").then(m => m.default || m)
  },
  {
    name: "privacy-settings___cs",
    path: "/cs/nastaveni-soukromi",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/privacy-settings.vue").then(m => m.default || m)
  },
  {
    name: "registration___cs___default",
    path: "/registrace",
    meta: registrationCG6YtlffPJMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: "registration___cs",
    path: "/cs/registrace",
    meta: registrationCG6YtlffPJMeta || {},
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/registration.vue").then(m => m.default || m)
  },
  {
    name: "security___cs___default",
    path: "/bezpecnost",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/security.vue").then(m => m.default || m)
  },
  {
    name: "security___cs",
    path: "/cs/bezpecnost",
    component: () => import("C:/FE02/_work/305/s/Gallery/pages/security.vue").then(m => m.default || m)
  }
]